import { Box, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { MouseEventHandler } from 'react';

import styles from './primary-filter-chip.module.css';

export const PrimaryFilterTag = ({
  label,
  isActive,
  id,
  onClick,
  onRemoveChip,
  color,
  isSelfSignupUser,
}: {
  label: string;
  isActive: boolean;
  id: string;
  onClick: MouseEventHandler<HTMLSpanElement>;
  onRemoveChip: MouseEventHandler<HTMLSpanElement>;
  color?: string;
  isSelfSignupUser?: boolean;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <Tag
      size="sm"
      height="1.8rem"
      className={styles.chip}
      flexShrink={0}
      onClick={onClick}
      ref={setNodeRef}
      style={style}
      data-testid="primary-filter-chip"
      {...listeners}
      {...attributes}
      role="button"
      aria-pressed={isActive}
    >
      <TagLabel fontSize="11.5px">
        {color && (
          <Box
            as="span"
            display="inline-block"
            width="8px"
            height="8px"
            borderRadius="2px"
            marginRight="5px"
            verticalAlign="middle"
            background={color}
          />
        )}
        {label}
      </TagLabel>
      {!isSelfSignupUser && (
        <TagCloseButton
          fontSize="14px"
          marginLeft="10px"
          width="9.5px"
          onClick={onRemoveChip}
          data-testid="primary-filter-chip-remove"
        />
      )}
    </Tag>
  );
};
